<template>
  <div class="LkMunMehHostViewForm">
    <div class="LkMunMehHostViewForm__content">
      <router-link class="LkMunMehHostViewForm__content__link" :to="{ name: ROUTES.FORM }">
        <h3
          class="LkMunMehHostViewForm__title"
          v-text="munMeh.name"
        />
      </router-link>

      <hr class="LkMunMehHostViewForm__line">
      <template v-if="munMeh.id">
        <div>
          <v-btn
            color="primary"
            rounded
            outlined
            class="mb-2"
            style="margin-top: 1rem;"
            :loading="isDownloading"
            @click="onExcelDownload"
            v-text="'Скачать шаблон'"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { LK_MUN_MEH_FORM_HOST_VIEW_ROUTES as ROUTES } from '@/views/LKMunMeh/HostView/utils'
import { LkMunMehApi } from '@/api/resources'
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import { toNumber } from 'lodash'

export default {
  name: 'LKMunMehHostViewForm',
  props: {
    munMeh: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    ROUTES,
    isDownloading: false,
  }),
  methods: {
    async onExcelDownload() {
      const api = new LkMunMehApi()
      const { munMeh } = this

      const link = api.downloadXlsx(toNumber(this.$route.params.formId))
      this.isDownloading = true
      try {
        await downloadLinkByGet(link, `${munMeh.name}.xlsx`)
      } catch (e) {
        this.$notice.errors(e)
      }
      setTimeout(() => {
        this.isDownloading = false
      }, 1500)
    },
  },
}
</script>

<style lang="scss">
.LkMunMehHostViewForm {
  @import "~@/views/LKMunMeh/styles/_MunMehFormStylesheet.scss";
}
</style>
